import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function UniqueMechanism() {
  const plants = [{
    name: 'Lavanda',
    compound: 'Linalool + acetato de linalilo',
    action: 'Reduce la presión arterial, desacelera el pulso, activa el sistema nervioso parasimpático'
  }, {
    name: 'Manzanilla',
    compound: 'Apigenina',
    action: 'Se une a los receptores GABA — los mismos que activan los ansiolíticos farmacéuticos — sin dependencia'
  }, {
    name: 'Pasiflora',
    compound: 'Crisina + flavonoides',
    action: 'Interrumpe los pensamientos en bucle actuando directamente sobre la actividad neuronal acelerada'
  }];
  return <section className="px-6 py-10 max-w-4xl mx-auto" data-id="element-213">
      <FadeIn data-id="element-214">
        <div className="text-lg md:text-xl leading-relaxed text-[#2D2A26] max-w-3xl mx-auto mb-8" data-id="element-215">
          <p className="mb-5" data-id="element-216">
            Aquí está la verdad que los médicos raramente tienen tiempo de
            explicarte en una consulta de 15 minutos:
          </p>

          <p className="font-bold text-2xl text-[#4A5D3A] mb-2" data-id="element-217">
            Tu sistema nervioso tiene un interruptor biológico.
          </p>
          <p className="font-bold text-2xl text-[#4A5D3A] mb-6" data-id="element-218">
            Y las plantas correctas — en la dosis correcta — saben exactamente
            dónde está.
          </p>

          <p data-id="element-219">
            No hablamos de creencias ancestrales vagas ni de folklore sin
            respaldo.
          </p>
          <p data-id="element-220">Hablamos de compuestos activos documentados científicamente:</p>
        </div>

        <img src="https://cdn.magicpatterns.com/uploads/nF7JkWjsNkWix8Soj3CbVR/imagen_4_para_la_pagina_de_venta.png" alt="Plantas medicinales — lavanda, manzanilla y pasiflora" className="w-full max-w-2xl mx-auto rounded-2xl shadow-lg mb-10" data-id="element-221" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12" data-id="element-222">
          {plants.map((plant, index) => <div key={index} className="bg-[#4A5D3A]/5 rounded-2xl p-6 border border-[#4A5D3A]/20 relative overflow-hidden" data-id="element-223">
              <div className="absolute top-0 right-0 w-24 h-24 bg-[#4A5D3A]/10 rounded-bl-full -mr-4 -mt-4" data-id="element-224"></div>
              <h3 className="font-serif text-3xl font-bold text-[#4A5D3A] mb-2" data-id="element-225">
                {plant.name}
              </h3>
              <p className="text-sm font-bold text-[#9B4F2B] mb-3 uppercase tracking-wider" data-id="element-226">
                {plant.compound}
              </p>
              <p className="text-[#2D2A26]/80 leading-relaxed" data-id="element-227">
                {plant.action}
              </p>
            </div>)}
        </div>

        <div className="bg-white rounded-3xl p-6 md:p-10 shadow-lg border border-[#C4A265]/30 max-w-3xl mx-auto relative" data-id="element-228">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-[#C4A265] text-white px-6 py-2 rounded-full font-bold tracking-wide text-sm" data-id="element-229">
            EL SECRETO
          </div>

          <p className="text-lg md:text-xl text-center mb-5 mt-2" data-id="element-230">
            Pero aquí está el secreto que nadie te cuenta en el pasillo de
            "infusiones" del supermercado:
          </p>

          <p className="text-2xl md:text-3xl font-serif font-bold text-center text-[#9B4F2B] mb-6" data-id="element-231">
            La dosis lo es absolutamente todo.
          </p>

          <div className="space-y-3 text-center text-[#2D2A26]/80" data-id="element-232">
            <p data-id="element-233">
              Un sobre comercial de manzanilla contiene aproximadamente 0.5
              gramos de planta seca.
            </p>
            <p data-id="element-234">
              Una dosis de impacto terapéutico real requiere entre 3 y 6 veces
              esa cantidad, preparada con un método específico de extracción.
            </p>
          </div>

          <div className="mt-8 text-center space-y-2" data-id="element-235">
            <p className="font-bold text-xl" data-id="element-236">No es la planta que falla.</p>
            <p className="font-bold text-xl text-[#4A5D3A]" data-id="element-237">
              Es la dosis. Es el método. Es la combinación.
            </p>
          </div>
        </div>

        <div className="text-center mt-12" data-id="element-238">
          <p className="text-xl mb-4" data-id="element-239">
            Y eso es exactamente — y solo eso — lo que cambia con el:
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-[#4A5D3A] tracking-tight mb-8" data-id="element-240">
            MÉTODO DE RESCATE BOTÁNICO
          </h2>

          <a href="https://pay.hotmart.com/Y104754180A" className="inline-block w-full max-w-lg mx-auto text-center bg-[#4A5D3A] text-[#FAF6F0] font-bold py-5 px-8 rounded-xl shadow-lg hover:bg-[#3a4a2e] transition-colors text-base md:text-lg" data-id="element-241">
            QUIERO EL PROTOCOLO COMPLETO → Acceso instantáneo por $6.39 USD
          </a>
        </div>
      </FadeIn>
    </section>;
}